"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDeliveryChannelHandler = updateDeliveryChannelHandler;
var _updateDeliveryChannelFailed = require("@ori-events/update-delivery-channel-failed");
var _requestOptions = require("../constants/requestOptions");
var _types = require("../types");
var _utils = require("../utils");
async function updateDeliveryChannelHandler({
  detail: {
    deliveryChannelId
  }
}) {
  const requestOptions = {
    ..._requestOptions.putRequestOptions,
    body: JSON.stringify({
      deliveryChannelId
    })
  };
  const response = await fetch(_types.RequestUrl.UpdateDeliveryChannel, requestOptions);
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if ((0, _updateDeliveryChannelFailed.isUpdateDeliveryChannelErrorResponse)(data)) {
    const errorEvent = new CustomEvent(_updateDeliveryChannelFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}
